import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { H3 } from "../typography"

export const Container = styled.div`
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  margin-bottom: 1rem;
  ${({ pointer }) =>
    pointer &&
    css`
      cursor: pointer;
    `}

  ${breakpoint("tablet")`
    margin-bottom: 0;
  `}
`

export const Skills = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const Skill = styled.div`
  padding: 0.25rem 1rem;
  border: 1px solid ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.primary};
  border-radius: 2rem;
  font-size: 0.8rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
`

export const Media = styled.div`
  overflow: hidden;
  height: 15rem;
  position: relative;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;

  ${breakpoint("desktop")`
    border-radius: 1rem;
  `}
`

export const Img = styled.img`
  height: 100%;
  width: 100%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  object-fit: cover;
  object-position: 50% 50%;
  margin: 0;

  ${breakpoint("desktop")`
    border-radius: 1rem;
  `}
`

export const Logo = styled.img`
  position: absolute;
  border-radius: 50%;
  width: 4.25rem;
  height: 4.25rem;
  object-fit: cover;
  bottom: 0.75rem;
  left: 0.75rem;
  margin: 0;
`

export const Text = styled.div`
  background-color: white;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  padding: 0.75rem;

  ${breakpoint("desktop")`
    padding: 0;
  `}

  > * {
    margin: 0;
    margin-top: 0.4rem;
  }
`

export const PlayButton = styled.svg`
  width: 1.5rem;
  height: 1.5rem;
  fill: white;
`

export const InterviewButton = styled.svg`
  width: 1.5rem;
  height: 1.5rem;
  fill: none;
`

export const Banner = styled.span`
  color: white;
  padding: 0.75rem 5px;
  font-weight: bold;
  text-align: center;
  background-color: hsla(0, 1%, 30%, 0.7);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
`

export const StyledH3 = styled(H3)`
  font-size: 1rem;
`

export const Div = styled.div`
  display: flex;
  right: 1rem;
  flex-direction: row;
  align-content: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
`

export const SvgDiv = styled.div`
  position: relative;
  bottom: 2.5rem;
  padding-right: 0.5rem;
`
